import { Component, Inject, OnInit, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { CustomValidators } from 'angular-custom-validators';
import { EmergencyPhoneInfo } from 'src/app/interfaces';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface EmergencyNumbersDialogData {
  emergencyPhoneNumbers: EmergencyPhoneInfo[];
  isOnlyRidePlanner: boolean;
}

@Component({
  selector: 'app-emergency-numbers',
  templateUrl: './emergency-numbers.component.html',
  styleUrls: ['./emergency-numbers.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatIconButton,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class EmergencyNumbersDialogComponent implements OnInit {
  phoneForm: FormGroup;
  isOnlyRidePlanner = signal(false);
  numbersCount = signal(0);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EmergencyNumbersDialogData,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EmergencyNumbersDialogComponent>,
  ) {
    this.isOnlyRidePlanner.set(data.isOnlyRidePlanner);
    this.phoneForm = this.fb.group({
      numbers: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    if (this.data.emergencyPhoneNumbers) {
      this.data.emergencyPhoneNumbers.forEach((info) => {
        this.addNumber(info);
      });
    }

    if (this.isOnlyRidePlanner()) {
      this.phoneForm.disable();
    }
  }

  get numbers() {
    return this.phoneForm.get('numbers') as FormArray;
  }

  addNumber(info?: EmergencyPhoneInfo) {
    const numberGroup = this.fb.group({
      name: [info?.name ?? '', Validators.required],
      phoneNumber: [info?.phoneNumber ?? '', [Validators.required, CustomValidators.phone]],
      description: [info?.description ?? '', Validators.required],
    });
    this.numbers.push(numberGroup);
    this.numbersCount.set(this.numbers.length);
  }

  removeNumber(index: number) {
    this.numbers.removeAt(index);
    this.numbersCount.set(this.numbers.length);
  }

  confirm() {
    if (this.phoneForm.valid) {
      this.dialogRef.close(this.phoneForm.value.numbers);
    }
  }
}
